export const tileBoxShadow =
  'inset 0 1px 4px 0 #fff, inset 0 -1px 2px 0 rgba(227,228,228,0.24), 0 0 16px 0 rgba(0,0,0,0.06)';
